import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

export default async function getApplicationComments(
    applicationId: number,
    abortController: AbortController,
) {
    try {
        if (!applicationId) {
            throw new Error('Invalid application id')
        }

        const { data } = await axios.get(
            // eslint-disable-next-line max-len
            `${config.API_BASE_URL}/api/v3/applications/${applicationId}/comments/`,
            {
                signal: abortController.signal,
                withCredentials: true,
            },
        )

        return data.results
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get application comments: ${axiosError.message}`,
            axiosError,
            { applicationId },
        )

        throw axiosError
    }
}
